import * as React from "react";
import "./SessionSelectOption.component.css";
import { components } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
function formatDate(timestamp, language) {
    const date = new Date(timestamp);
    const locale = language.startsWith("de") ? "de-DE" : "en-US";
    return date.toLocaleString(locale);
}
export function SessionSelectOption(props) {
    var _a;
    const { session, deleteVisible, onDeleteClicked } = props.data;
    const { i18n } = useTranslation();
    return (React.createElement(components.Option, Object.assign({}, props),
        React.createElement("div", { className: "session-select-option-container" },
            React.createElement("div", { className: "session-select-option-text" },
                React.createElement("span", { className: "session-select-option-title" }, session.name),
                React.createElement("span", { className: "session-select-option-subtext" },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", "users"] }),
                    session.participantCount),
                session.modified && (React.createElement("span", { className: "session-select-option-date" },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", "clock"] }),
                    formatDate(session.modified, (_a = i18n.resolvedLanguage) !== null && _a !== void 0 ? _a : i18n.language)))),
            React.createElement("div", { style: { flexGrow: "1" } }),
            deleteVisible && (React.createElement("button", { className: "icon-button", onClick: () => {
                    onDeleteClicked(session);
                } },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "trash-alt"] }))))));
}
